// extracted by mini-css-extract-plugin
module.exports = {"layout":"Pc_layout__oY3v0","header":"Pc_header__Rqzka","header__title":"Pc_header__title__MnN4F","header__agent":"Pc_header__agent__e2dym","main":"Pc_main__h1TUA"};